<template>
  <!-- 2023-12月及12月之后的数据页面 -->
  <div class="page">
    <div class="nucleustit">
      <div class="tit">核心数据</div>
      <div>
        <el-date-picker style="width: 130px; margin-left: 10px" size="mini" v-model="currDate" type="month"
          value-format="timestamp" :picker-options="{
            disabledDate(date) {
              return date.getTime() < 1698768000000;
            },
          }" placeholder="选择日期" @change="changePicker" :clearable="false">
        </el-date-picker>
      </div>
    </div>
    <div class="tabLine">
      <div style="display: flex" >
        <div class="tabItem" :class="[tabIndex === 0 ? 'active' : '']" @click="changeTabIndex(0)" >
          门店数据
        </div>
        <div class="tabItem" :class="[tabIndex === 1 ? 'active' : '']" @click="changeTabIndex(1)">
          员工排名
        </div>
      </div>
      <div style="display: flex"  v-if="$buttonAuthority('shuju-Newmoneypk-shopEdit')">
        <div v-if="tabIndex === 0" @click="mendianSetParams_state = true" class="tabItem">
          设置门店数据参数
        </div>
        <!-- <div v-if="tabIndex === 1" @click="configStaff" class="tabItem">
          设置员工数据参数
        </div> -->
      </div>
    </div>
    <div v-if="tabIndex === 0">
      <mendianpk :refresh="refresh"></mendianpk>
    </div>
    <div v-if="tabIndex === 1">
      <stafftc :refresh="refresh"></stafftc>
    </div>
    <div v-if="mendianSetParams_state">
      <mendianSetParams @submit="submit_mendianSetParams"></mendianSetParams>
    </div>
    <div v-if="staffSetParams_state">
      <staffSeeParams @submit="submit_staffSetParams"></staffSeeParams>
    </div>
  </div>
</template>
<script>
import mendianpk from "./newpk/mendianpk.vue";
import mendianSetParams from "./newpk/mendianSetParams.vue";
import stafftc from "./newpk/stafftc.vue";
import staffSeeParams from "./newpk/staffSeeParams.vue";
export default {
  components: { mendianpk, mendianSetParams, staffSeeParams,stafftc },
  data() {
    return {
      currDate: "",

      tabIndex: 0,
      // setParams
      refresh: 1,
      mendianSetParams_state: false,
      staffSetParams_state: false,
      shopOptions: [{ //门店筛选
        value: '',
        label: '全部'
      }, {
        value: '5e9412e0b2bfbc089daerr12',
        label: '金水区店'
      }, {
        value: '5e9412e0b2bfbc089daerr18',
        label: '郑东新区店'
      }],

    };
  },
  computed: {
    shopId() {
      return this.$store.state.shopId;
    },
  },
  created() {
    this.currDate = new Date();
    sessionStorage.setItem("pkMonth", this.$public.FTimeStr10(this.currDate));
  },
  mounted() {
    console.log(Date.now(), "Date.now()");
  },
  methods: {
  
    configStaff() {
      this.staffSetParams_state = true;
      console.log("点击了---", this.staffSetParams_state);
    },
    changeTabIndex(i) {
      this.tabIndex = i;
    },
    changePicker(val) {
      sessionStorage.setItem("pkMonth", this.$public.FTimeStr10(val));
      this.refresh++;
    },
    // 设置门店信息
    submit_mendianSetParams(obj) {
      this.mendianSetParams_state = false;
      this.changeTabIndex(1);
      if (obj.type === "success") {
        this.refresh++;
      }
    },
    // 设置员工信息
    submit_staffSetParams(obj) {
      this.staffSetParams_state = false;
      if (obj.type === "success") {
        this.refresh++;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.page {
  width: 100%;
  height: 100vh;

  .cell {
    display: flex;
    background: rgba(239, 210, 187, 0.5);
    border-radius: 10px;

    div {
      // border: 1px solid gray;
      padding: 10px 15px;

    }

    .active {
      background-color: $mainColor;
      color: #fff;
      border-color: $mainColor;
      font-size: 14px;
      border-radius: 8px;
      cursor: pointer;
    }
  }

  .nucleustit {
    display: flex;
    justify-content: space-between;
    height: 57px;
    box-sizing: border-box;
    padding: 16px 16px 0 16px;
    background-color: #fff;

    .tit {
      color: $fontColor;
      font-size: 18px;
      font-weight: bold;
      margin: 4px 0;
      padding: 0 6px;
      box-sizing: border-box;
      height: 20px;
      line-height: 20px;
    }
  }

  .tabLine {
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    margin-top: 12px;
    padding: 25px 20px 20px;
    border-bottom: 1px solid #f1f1f1;
    border-radius: 10px 10px 0 0;

    .tabItem {
      font-size: 14px;
      color: #666660;
      border: 1px solid #ddd;
      border-radius: 2px;
      margin-right: 20px;
      line-height: 30px;
      padding: 0 17px;
      cursor: pointer;

      &.active {
        background-color: $mainColor;
        color: #fff;
        border-color: $mainColor;
      }
    }
  }
}
</style>
